import {
  useDispatch,
  useEffect,
  useState,
  useNavigate,
  useParams,
  useSelector,
  useLocation,
  titleToUrl,
} from '../../../imports/generalImport';
import { Box, Container, Button } from '../../../imports/muiImport';
import { Helmet } from 'react-helmet-async';
import { CircularProgress } from '@mui/material';
import MobileProductDetailImage from '../../mobileComponents/mobileProductDetails/MobileProductDetailImage';
import MobileProductDetails from '../../mobileComponents/mobileProductDetails/MobileProductDetails';
import MobileGiftCardPurchase from '../../mobileComponents/mobileGiftCardPurchase/MobileGiftCardPurchase';
import ScrollToTop from '../../../components/other/ScrollToTop';
import PageNotFound from '../../../pages/OTHERPAGE/PageNotFound';
import { getUniqueClass } from '../../../hooks/utilsFn/utilsFn';
import { wipeOutProductDetails } from '../../../store/productInfo/action';
import { wipeOutDenomination } from '../../../store/productDetails/action';
import { resetPosts } from '../../../store/giftcardDesign/action';
import { productDetailHandler } from '../../../pages/PRODUCTDETAILS/ProductDetail';
import { saveCampaignTracking } from '../../../shared/campaignTracker';

function MobileHomeProductDetails() {
  const [currentProductId, setCurrentProductId] = useState(null);
  const [productLoading, setProductLoading] = useState(true);
  const [productFound, setProductFound] = useState(false);
  const [outOfStock, setOutOfStock] = useState(false);
  const [showRangeDenomination, setShowRangeDenomination] = useState(false);

  const ProductDetail = useSelector((state) => state.ProductDetail?.allData);

  let { title: urlTitle, id: urlId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const canonicalUrl = `https://www.99gift.in/card-details/${urlId}/${titleToUrl(urlTitle)}`;

  useEffect(() => {
    saveCampaignTracking(location);
  }, [location.pathname, location.search]);

  useEffect(() => {
    setProductLoading(true);
    if (urlId != currentProductId) {
      dispatch(wipeOutProductDetails());
      dispatch(wipeOutDenomination());
      dispatch(resetPosts());

      productDetailHandler({
        urlId,
        urlTitle,
        dispatch,
        setProductFound,
        setPageLoading: setProductLoading,
        setOutOfStock,
        setShowRangeDenomination,
        isMobile: true
      });

      setCurrentProductId(urlId);
    } else {
      navigate('/');
    }
  }, [urlId, urlTitle]);

  if (productFound) {
    return <PageNotFound />;
  }

  if (productLoading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Helmet>
        <title>
          {ProductDetail?.['metaSEO']?.['metaTitle']
            ? ProductDetail?.['metaSEO']?.['metaTitle']
            : `Buy ${urlTitle} - 99gift.in`}
        </title>

        <meta
          property="og:title"
          content={
            ProductDetail?.['metaSEO']?.['metaOGTitle']
              ? ProductDetail?.['metaSEO']?.['metaOGTitle']
              : `Buy ${urlTitle} - 99gift.in`
          }
        />

        <meta
          name="description"
          content={
            ProductDetail?.['metaSEO']?.['metaDescription']
              ? ProductDetail?.['metaSEO']?.['metaDescription']
              : `Get instant discounts on ${urlTitle} when you purchase them online through 99gift. Take advantage of great deals on ${urlTitle}, coupons, and promo codes.`
          }
        />

        <meta
          name="og:description"
          content={
            ProductDetail?.['metaSEO']?.['metaOGDescription']
              ? ProductDetail?.['metaSEO']?.['metaOGDescription']
              : `Get instant discounts on ${urlTitle} when you purchase them online through 99gift. Take advantage of great deals on ${urlTitle}, coupons, and promo codes.`
          }
        />

        <meta property="og:url" content={canonicalUrl} />
        <link rel="canonical" href={canonicalUrl} />

        {ProductDetail?.['metaSchema'] && (
          <script type="application/ld+json">{ProductDetail?.['metaSchema']}</script>
        )}
      </Helmet>

      <Container
        sx={{
          minHeight: '100vh',
          backgroundColor: 'white.main',
          display: 'flex',
          justifyContent: 'flex-start',
          flexDirection: 'column',
          alignItems: 'center',
          pt: 1,
          mb: 6,
          p: 0,
        }}
      >
        <ScrollToTop />
        <MobileProductDetailImage image={ProductDetail?.image} />
        <MobileProductDetails product={ProductDetail} />

        <Box
          sx={{
            position: 'fixed',
            bottom: 90,
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            py: 1,
            bgcolor: 'white.main',
            zIndex: 1000,
          }}
        >
          {outOfStock ? (
            <Button
              variant="contained"
              fullWidth
              className={`${getUniqueClass(ProductDetail?.id, ProductDetail?.title)}`}
              sx={{
                textTransform: 'capitalize',
                bgcolor: 'error.main',
                color: '#fff',
                fontWeight: 'bold',
                borderRadius: 0,
                py: 1.5,
                fontSize: '1.425rem',
                boxShadow: 0,
                '&:hover': {
                  bgcolor: 'error.dark',
                },
              }}
            >
              Currently Out of Stock
            </Button>
          ) : (
            <MobileGiftCardPurchase showRangeDenomination={showRangeDenomination} />
          )}
        </Box>
      </Container>
    </>
  );
}

export default MobileHomeProductDetails;
